export default __webpack_public_path__ + "static/media/walk-in.c0704b04.png";